<template>
  <div id='app'>
    <router-view />
  </div>
</template>
<script>
export default {
  name: 'App'
}
</script>

<style lang='scss'>
body, html{
  padding: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f6f6f6;
}
</style>
